import React from "react";
import cn from "classnames";

import PageHeader from "./header";
import PageFooter from "./footer";
import PageAction from "./action";

export type Props = {|
  +children?: React.Node,
  +className?: string,
  +title?: string,
  +backTo?: string,
  +hasFooter?: boolean,
  +action?: boolean,
  +full?: boolean,
|};

function Page({
  className,
  children,
  title,
  backTo,
  hasFooter,
  action,
  full,
}: Props): React.Node {
  const classes = cn("page-container", className, full ? "p-0" : null);
  const showHeader = title !== "" || backTo !== "";

  return (
    <div className="container">
      {showHeader ? <PageHeader title={title} backTo={backTo} /> : null}
      <div className={classes}>{children}</div>
      {hasFooter ? <PageFooter /> : null}
      {action ? <PageAction>{action}</PageAction> : null}
    </div>
  );
}

Page.defaultProps = {
  title: "",
  backTo: "",
  footer: null,
  hasFooter: false,
  action: null,
  full: false,
};

Page.Header = PageHeader;
Page.Footer = PageFooter;
Page.Action = PageAction;

export default Page;
